import { useCallback, useState } from "react";
import { message } from "antd";
import {
    getIgnoredReturns,
    getReturnHistory,
    getReturns,
} from "../api/transactionScheduleApi";

export default function useTransactionScheduleReturns() {
    const [returns, setReturns] = useState([]);
    const [loadingUnmatchedReturns, setLoadingUnmatchedReturns] = useState(false);

    const [returnHistory, setReturnHistory] = useState([]);
    const [loadingReturnHistory, setLoadingReturnHistory] = useState(false);

    const [ignoredReturns, setIgnoredReturns] = useState([]);
    const [loadingIgnoredReturns, setLoadingIgnoredReturns] = useState(false);

    const loadUnmatchedReturns = useCallback(async () => {
        setLoadingUnmatchedReturns(true);
        try {
            const data = await getReturns();
            const rows = (data || []).map((item) => ({
                ...item,
                key: item.statementId,
            }));
            setReturns(rows);
            return rows;
        } catch (error) {
            message.error(error.message || "Буцаалтын мэдээлэл ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingUnmatchedReturns(false);
        }
    }, []);

    const loadReturnHistory = useCallback(async () => {
        setLoadingReturnHistory(true);
        try {
            const data = await getReturnHistory();
            const rows = (data || []).map((item, index) => ({
                ...item,
                key: item.id || `${item.statementId}-${index}`,
            }));
            setReturnHistory(rows);
            return rows;
        } catch (error) {
            message.error(error.message || "Буцаалтын түүх ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingReturnHistory(false);
        }
    }, []);

    const loadIgnoredReturns = useCallback(async () => {
        setLoadingIgnoredReturns(true);
        try {
            const data = await getIgnoredReturns();
            const rows = (data || []).map((item) => ({
                ...item,
                key: item.statementId,
            }));
            setIgnoredReturns(rows);
            return rows;
        } catch (error) {
            message.error(error.message || "Буцаалт биш жагсаалт ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingIgnoredReturns(false);
        }
    }, []);

    const refreshReturnsData = useCallback(async () => {
        await Promise.all([
            loadUnmatchedReturns(),
            loadReturnHistory(),
            loadIgnoredReturns(),
        ]);
    }, [loadIgnoredReturns, loadReturnHistory, loadUnmatchedReturns]);

    return {
        returns,
        returnHistory,
        ignoredReturns,
        loadingUnmatchedReturns,
        loadingReturnHistory,
        loadingIgnoredReturns,
        loadUnmatchedReturns,
        loadReturnHistory,
        loadIgnoredReturns,
        refreshReturnsData,
    };
}